import { render, staticRenderFns } from "./signFor.vue?vue&type=template&id=2ccbe64b&scoped=true&"
import script from "./signFor.vue?vue&type=script&lang=js&"
export * from "./signFor.vue?vue&type=script&lang=js&"
import style0 from "./signFor.vue?vue&type=style&index=0&id=2ccbe64b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccbe64b",
  null
  
)

export default component.exports